import { render, staticRenderFns } from "./select.vue?vue&type=template&id=56add0fd&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/domains/b2b/htdocs/local/templates/b2bmodern_default/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56add0fd')) {
      api.createRecord('56add0fd', component.options)
    } else {
      api.reload('56add0fd', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=56add0fd&", function () {
      api.rerender('56add0fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/select.vue"
export default component.exports